import { render } from "./CharaWallet.vue?vue&type=template&id=1470515c&scoped=true"
import script from "./CharaWallet.vue?vue&type=script&lang=js"
export * from "./CharaWallet.vue?vue&type=script&lang=js"

import "./CharaWallet.vue?vue&type=style&index=0&id=1470515c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1470515c"]])

export default __exports__